import { createAction, props } from '@ngrx/store';
import { RequestNationalityManagerCreate, ResponseNationalityManagerCreate } from '../../shared/interfaces';
import { NationalityManagerCreateTypes } from '../../shared/enums';

export const getNationalityManagerCreate = createAction(
    NationalityManagerCreateTypes.NATIONALITY_MANAGER_CREATE,
    props<{ request: RequestNationalityManagerCreate}>()
);

export const getNationalityManagerCreateSucess = createAction(
    NationalityManagerCreateTypes.NATIONALITY_MANAGER_CREATE_SUCCESS,
    props<{ response: ResponseNationalityManagerCreate }>()
);

export const getNationalityManagerCreateError = createAction(
    NationalityManagerCreateTypes.NATIONALITY_MANAGER_CREATE_ERROR,
    props<{ payload: any }>()
);

export const cleanState = createAction(
    NationalityManagerCreateTypes.CLEAN_STATE
);

